import { useState, useEffect } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import { connect } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJsonFromBack, saveJsonLearnToBack } from '../../../store/jsonSliceLearn';
import { FaTrash, FaSave, FaCopy } from "react-icons/fa";

import Title from "../../../components/Title";
import Button from "../../../components/Button";
import TextInput from "../../../components/TextInput";

const SettingsManage = ({ loading, error }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { chapterName, folderName: urlFolderName } = useParams();
  const jsonData = useSelector(state => state.jsonLearn.jsonData);
  const currentFolderName = useSelector(state => state.procedure?.currentFolderName);
  const currentFilename = useSelector(state => state.procedure?.currentFilename);

  // États pour stocker les données des paramètres 
  const [Contents, setContents] = useState({
    usage: "Fichier des questionnaires liés aux procédures (process) d'iXiWORK.",
    contentVersion: "",
    ownerName: "",
    ownerIdentifier: "",
    appVersion: "",
    chapter: "",
    calibrateAfterStageID: 0,
    langCode: ""
  });

  // État pour stocker le fichier téléchargé
  const [file, setFile] = useState(null);
  // Pour stocker la langue sélectionnée si besoin (exemple: 'fr')
  const [lang, setLang] = useState('fr');

  // État pour stocker le message de succès
  const [successMessage, setSuccessMessage] = useState('');

  // Charger les données initiales
  useEffect(() => {
    if (urlFolderName) {
      // Nettoyer d'abord le .json, puis le _learn
      const cleanName = urlFolderName.replace(/\.json$/, '');
      const base = cleanName.replace(/_learn$/, '');
      const activeChapterName = chapterName || base.split('_')[0];
      const languageFolder = `${base}/learn`;
      const learnFilename = `${base}_learn.json`;
      const finalFolderPath = `${activeChapterName}/${languageFolder}`;

      dispatch(fetchJsonFromBack({
        folderName: finalFolderPath,
        filename: learnFilename
      }));
    }
  }, [urlFolderName, dispatch]);
  useEffect(() => {
    if (!jsonData) return;

    const settings = jsonData.settings || {};

    setContents({
      usage: jsonData.usage || "Fichier des questionnaires liés aux procédures (process) d'iXiWORK.",
      contentVersion: settings?.contentVersion || "",
      ownerName: settings?.ownerName || "",
      ownerIdentifier: settings?.ownerIdentifier || "",
      appVersion: settings?.appVersion || "",
      chapter: settings?.chapter || "",
      calibrateAfterStageID: settings?.calibrateAfterStageID || 0,
      langCode: settings?.langCode || ""
    });
  }, [jsonData, urlFolderName]);

  // Afficher le message de succès
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => setSuccessMessage(''), 3000);
    }
  }, [successMessage]);

  const handleChange = (field, value) => {
    setContents({ ...Contents, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedData = {
        usage: Contents.usage || jsonData?.usage || "Fichier des questionnaires liés aux procédures (process) d'iXiWORK.",
        settings: {
          contentVersion: Contents.contentVersion || jsonData?.settings?.contentVersion || "1.0",
          ownerName: Contents.ownerName || jsonData?.settings?.ownerName || '',
          ownerIdentifier: Contents.ownerIdentifier || jsonData?.settings?.ownerIdentifier || '',
          appVersion: Contents.appVersion || jsonData?.settings?.appVersion || "",
          chapter: Contents.chapter || jsonData?.settings?.chapter || "",
          calibrateAfterStageID: Contents.calibrateAfterStageID || jsonData?.settings?.calibrateAfterStageID || 0,
          unit: Contents.unit || jsonData?.settings?.unit || "mm",
          langCode: Contents.langCode || jsonData?.settings?.langCode || ""
        },
        process: {
          topics: Array.isArray(jsonData?.process?.topics) ? jsonData.process.topics : [],
          courses: Array.isArray(jsonData?.process?.courses) ? jsonData.process.courses : []
        }
      };

      // Mise à jour du state Redux
      dispatch({ type: 'jsonLearn/updateJsonData', payload: updatedData });

      // Construction des bons paramètres pour le chemin learn
      const cleanName = urlFolderName.replace(/\.json$/, '');
      const base = cleanName.replace(/_learn$/, '');
      // Priorité au chapterName réel de l'URL (cohérent avec la lecture ci-dessus) : le
      // split par "_" ne fonctionne que pour l'ancienne convention "Chapitre_suffixe" et
      // renvoie le nom de variante entier (pas de "_") pour les noms libres/accentués,
      // ce qui écrivait le fichier learn au mauvais endroit.
      const activeChapterName = chapterName || base.split('_')[0];
      const languageFolder = `${base}/learn`;
      const learnFilename = `${base}_learn.json`;

      await dispatch(saveJsonLearnToBack({
        updatedData,
        chapterName: activeChapterName,
        languageFolder,
        filename: learnFilename
      }));

      setSuccessMessage('Paramètres enregistrés avec succès !');
    } catch (error) {
      alert('Erreur lors de la sauvegarde des paramètres.');
    }
  };

  const handleCancel = () => navigate(-1);

  // TEMPORAIRE : Affichage des données reçues dans le JSX
  const renderDebugInfo = () => (
    <div style={{ background: '#f8f9fa', padding: '10px', margin: '10px 0', border: '1px solid #ddd' }}>
      <h5>🔍 DEBUG INFO</h5>
      <p><strong>Loading:</strong> {String(loading)}</p>
      <p><strong>Error:</strong> {error ? JSON.stringify(error) : 'null'}</p>
      <p><strong>jsonData existe:</strong> {jsonData ? 'OUI' : 'NON'}</p>
      <p><strong>Type jsonData:</strong> {typeof jsonData}</p>
      {jsonData && (
        <details>
          <summary>Contenu jsonData (cliquez pour développer)</summary>
          <pre style={{ background: 'white', padding: '10px', fontSize: '12px' }}>
            {JSON.stringify(jsonData, null, 2)}
          </pre>
        </details>
      )}
    </div>
  );

  if (loading) return <div>Chargement des informations...</div>;

  // Ne pas afficher l'erreur si on a quand même des données
  if (error && !jsonData) {
    return <div className="alert alert-danger">{error.message || String(error)}</div>;
  }

  return (
    <div className="form-container p-4" alt="titre du module d'apprentissage">
      <Title text={`Paramètre des évaluations`} className="text-center text-primary" />
      {/*{renderDebugInfo()}  DEBUG TEMPORAIRE */}

      {successMessage && (
        <div className="alert alert-success text-center">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div alt="Version" className="col-md-3" title="Numero ou référence de version
          Peut correspondre à la version du document original
          (non visible dans iXiLEARN)">
            <TextInput
              label="Version ℹ️"
              placeholder="Ex : 1.2"
              value={Contents.contentVersion}
              onChange={(e) => handleChange("contentVersion", e.target.value)}
            />
          </div>
          <div alt="Nom" className="col-md-5" title="Nom du propriétaire du module
          (généralement le fabricant - non visible)">
            <TextInput
              label="Nom du propriétaire ℹ️"
              placeholder="Ex : iXiVERSE"
              value={Contents.ownerName}
              onChange={(e) => handleChange("ownerName", e.target.value)}
            />
          </div>
          <div alt="identifiant" className="col-md-4" title="Identifiant numérique du propriétaire
          (Généralement le N° de siret ou TVA intra-communautaire - non visible)">
            <TextInput
              label="Identifiant du propriétaire ℹ️"
              placeholder="ex: 00000000000000"
              value={Contents.ownerIdentifier}
              onChange={(e) => handleChange("ownerIdentifier", e.target.value)}
            />
          </div>
        </div>

        <div alt="Boutons" className="d-flex justify-content-center gap-3 mt-4">
          <Button
            text="Annuler"
            className="btn btn-outline-secondary btn-lg ms-5"
            onClick={handleCancel}
          />
          <Button
            text="Enregistrer"
            type="submit"
            className="btn btn-outline-primary btn-lg me-5"
          />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.jsonLearn.loading,
  error: state.jsonLearn.error,
  jsonData: state.jsonLearn.jsonData
});

export default connect(mapStateToProps)(SettingsManage);

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license